import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

import { ref, watch } from 'vue'
import { ElDialog, ElMessage, ElInput, ElButton, ElRadio, ElRadioGroup } from 'element-plus'
import { resourcerFileUpload } from '@/api/design/resource'
import { useSdkStore } from '@/stores/sdk'


export default /*@__PURE__*/_defineComponent({
  __name: 'JSONImport',
  setup(__props) {

const sdkStore = useSdkStore()
const desginsdk = sdkStore.getSdk()

const dialogVisible = ref(false)
const format = ref<'yft' | 'ck'>('yft')
const jsonText = ref('')

const onConfirm = async () => {
    const txt = jsonText.value.trim()
    if (!txt) { ElMessage.warning('请输入JSON数据'); return }
    try {
        JSON.parse(txt)
    } catch {
        ElMessage.error('JSON格式不正确')
        return
    }
    try {
        if (format.value === 'yft') {
            await desginsdk.designOpt.requireJson(txt)
        } else {
            await desginsdk.designOpt.requireCKJSON(txt)
        }
        dialogVisible.value = false
    } catch (error) {
        console.error(error)
        ElMessage.error('导入失败')
    }
}
watch(dialogVisible, (newVal) => {
    if (!newVal) {
        jsonText.value = ''
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "w-full h-40px flex items-center px-[15px] cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
    }, "导入JSON"),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "导入JSON",
      width: "520"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElInput), {
          modelValue: jsonText.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((jsonText).value = $event)),
          type: "textarea",
          placeholder: "请输入JSON数据",
          rows: 8
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ElButton), {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            style: {"background-color":"#2a66ff"},
            onClick: onConfirm
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("确认导入", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})